import { render, staticRenderFns } from "./ProductDeletion.vue?vue&type=template&id=b7353962&scoped=true"
import script from "./ProductDeletion.vue?vue&type=script&lang=ts"
export * from "./ProductDeletion.vue?vue&type=script&lang=ts"
import style0 from "./ProductDeletion.vue?vue&type=style&index=0&id=b7353962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7353962",
  null
  
)

export default component.exports